import { render } from "./lessonOwnerDetail.vue?vue&type=template&id=0c0a1556&scoped=true"
import script from "./lessonOwnerDetail.vue?vue&type=script&lang=js"
export * from "./lessonOwnerDetail.vue?vue&type=script&lang=js"

import "./lessonOwnerDetail.vue?vue&type=style&index=0&id=0c0a1556&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0a1556"]])

export default __exports__